export const LOCATION_PDP = 'pdp';
export const LOCATION_SEARCH_BROWSE = 's/b';

export const SUSPECTED_TRADE_ACQUISITION_VIEWS = 'SUSPECTED_TRADE_ACQUISITION_VIEWS';
export const SUSPECTED_TRADE_ACQUISITION_DISMISSED = 'SUSPECTED_TRADE_ACQUISITION_DISMISSED';
export const SUSPECTED_TRADE_ACQUISITION_MAX_VIEWS = 10;

export const TRADE_WINDFALL_REFERRAL_KEY = 'windfall';
